module.exports = __webpack_public_path__ + "static/media/full_input_patient.93035679.png";